// @flow
import * as React from 'react'
import MagnifyingGlassIcon from 'icon/MagnifyingGlassIcon'
import { type Filters } from '..'

import './SearchBar.module.scss'

type Props = {
  filters: Filters,
  onUpdateFilters: (filters: $Shape<Filters>) => void,
  onClearFilters: () => void,
  onSearch: () => void,
  placeholder: string,
}

export default class SearchBar extends React.Component<Props> {
  rootNode: ?HTMLFormElement

  render = () => {
    return (
      <form styleName="root" onSubmit={this.handleSubmit} ref={node => (this.rootNode = node)}>
        <div styleName="control">
          <input
            styleName="input"
            type="search"
            value={this.props.filters.location}
            placeholder={this.props.placeholder}
            onChange={this.handleInputChange}
          />
          <button styleName="button" type="submit">
            <MagnifyingGlassIcon strokeColor="#5196cb" layout="heightConstrained" />
          </button>
        </div>
      </form>
    )
  }

  handleSearch = () => {
    this.props.onSearch()
  }

  handleInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.props.onUpdateFilters({ location: event.target.value })
  }

  handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    this.props.onSearch()
  }
}
